import { PropsWithChildren, useState } from 'react';
import styled from 'styled-components';

import TooltipDark from './TooltipDark';

const Target = styled.div`
	position: relative;
`;

export default function TooltipTarget(
	props: PropsWithChildren<{ title: string; direction?: 'north' | 'east' | 'south' | 'west' }>,
) {
	const [hover, setHover] = useState(false);

	const direction = props.direction || 'south';

	return (
		<Target onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
			<TooltipDark isHovered={hover} direction={direction}>
				{props.title}
			</TooltipDark>
			{props.children}
		</Target>
	);
}
